
import { GetPrivateFile } from '@/api-server/modules/defaultServer';
import { momentFormat } from '@/utils/formatter'
import { ElLoading } from 'element-plus';
import { defineComponent, onMounted, ref } from 'vue'

import { CommonDialog, MediaList } from '@/components/Common'

interface DialogPreview {
  show: boolean;
  urls: string[];
}

export default defineComponent({
  components: {
    CommonDialog,
    MediaList
  },
  props: {
    info: Object,
    acceptSite: String,
    appId: String,
  },

  setup(props) {
    const preview = ref<DialogPreview>({
      show: false,
      urls: [],
    });

    const audioDialog = ref<DialogPreview>({
      show: false,
      urls: [],
    })

    const videoDialog = ref<DialogPreview>({
      show: false,
      urls: [],
    })

    const thumb = ref('')

    async function getPrivateUrl(imgUrl: any) {
      const postData: BUSINESS_SERVE_PLATFORM_PC.GetPrivateFileRequestBody = {
        file_name: imgUrl.name ? imgUrl.name: imgUrl,
      }
      if (props.appId) {
        postData.app_id = props.appId
      }
      const {
        data: { data: privateResult },
      } = await GetPrivateFile.fetch(postData);
      return privateResult;
    }

    const onClosePreview = () => {
      preview.value.show = false
    }

    const handlePicture = async (pictureList: string) => {
      if (preview.value.urls.length <= 0) {
        const loading = ElLoading.service({
          lock: true,
          text: "请求中",
        });
        try {
          const promisess = [ ...new Set(pictureList) ].map((file: string) => getPrivateUrl(file))
          preview.value.urls = await Promise.all(promisess) as string[]
          preview.value.show = true;
          loading.close();
        } catch (e) {
          loading.close();
        }
      } else if (preview.value.urls.length > 0) {
        preview.value.show = true;
      }
    }

    const handleAudio = (files: string[]) => {
      audioDialog.value.urls.length <=0 && (audioDialog.value.urls = [...new Set(files)])
      audioDialog.value.show = true
    }

    const handleVideo = (files: string[]) => {
      videoDialog.value.urls.length <=0 && (videoDialog.value.urls = [...new Set(files)])
      videoDialog.value.show = true
    }

    onMounted(async () => {
      if (props.info?.pictureList?.length > 0) {
        thumb.value = await getPrivateUrl(props.info?.pictureList[0]) || ''
      }
    })

    return {
      momentFormat,
      preview,
      onClosePreview,
      handlePicture,
      audioDialog,
      videoDialog,
      handleAudio,
      handleVideo,
      thumb,
    }
  }
})
